import { instance } from "config/axiosInstance";

// note: declare base url
const baseURL = process.env.REACT_APP_TENANT_BE;

export async function getContract(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL }).get(pathname + queryParams);
}

export async function getDocumentContract(pathname, queryParams = "") {
  return await instance({ baseURL: baseURL + "/contract" }).get(
    pathname + queryParams
  );
}

export async function createContract(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).post("/contract" + pathname, body);
}

export async function updateContract(pathname, body) {
  return await instance({
    baseURL: baseURL,
  }).patch("/contract" + pathname, body);
}

export async function deleteContract(pathname, queryParams) {
  return await instance({
    baseURL: baseURL,
  }).post("/contract" + pathname + queryParams);
}

export async function updateIsAccepted(pathname) {
  return await instance({
    baseURL: baseURL,
  }).post("/contract" + pathname);
}
